<template>
  <v-text-field
    outlined
    hide-details
    dense
    :disabled="disabled"
    :value="value"
    :placeholder="placeholder"
    @keydown="(v) => $emit('keydown', v)"
    @input="(v) => $emit('input', v)"
  />
</template>

<script>
export default {
  props: {
    value: String,
    disabled: Boolean,
    placeholder: String,
  },
};
</script>
